import angular from 'angular';
import Logger from '../../../shared/logger';

export const PositionReportService = (Restangular) => {
    const createPositionReport = function (positionId) {
        return Restangular
            .one('position', positionId)
            .all('report')
            .post('')
            .catch(error => Logger.error(error));
    };

    const updatePositionReport = function (positionId, reportId, data) {
        return Restangular
            .one('position', positionId)
            .one('report', reportId)
            .customPUT(data)
            .catch(error => Logger.error(error));
    };

    const refreshPositionReport = function (positionId, reportId) {
        return Restangular
            .one('position', positionId)
            .one('report', reportId)
            .all('refresh')
            .get('')
            .catch(error => Logger.error(error));
    };

    const refreshTalenyaInsightsPart = function (positionId, reportId) {
        return Restangular
            .one('position', positionId)
            .one('report', reportId)
            .one('refresh', 'talenyaInsightsPart')
            .get('')
            .catch(error => Logger.error(error));
    };

    const getEmployerActivityReport = function(body) {
        return Restangular.all('position')
            .all('report')
            .all('employerActivityReport')
            .post(body)
            .catch(error => Logger.error(error));
    }

    const refreshSearchCriteriaPart = function (positionId, reportId) {
        return Restangular
            .one('position', positionId)
            .one('report', reportId)
            .one('refresh', 'searchCriteriaPart')
            .get('')
            .catch(error => Logger.error(error));
    };

    return {
        createPositionReport,
        updatePositionReport,
        refreshPositionReport,
        refreshTalenyaInsightsPart,
        refreshSearchCriteriaPart,
        getEmployerActivityReport,
    };
};

angular
    .module('TALENYA-FE')
    .factory('PositionReportService', PositionReportService);

